import React, { createContext } from "react";
import Cookies from "universal-cookie";
import { TOKEN_NAME } from "../config";
import useGetUserCompanies from "../hooks/company/useGetUserCompanies";

const WorkspaceContext = createContext({});
const cookies = new Cookies();

export const WorkspaceProvider = ({ children }) => {
  const token = cookies.get(TOKEN_NAME);
  const isAuth = Boolean(token);

  const {
    companies,
    totalCount,
    paginationData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isFetching,
    isError,
    refetch,
    selectedAndDefault,
    selectedCompany,
    defaultCompany,
    isSameSelectedAndDefault,
  } = useGetUserCompanies({ enabled: isAuth });

  return (
    <WorkspaceContext.Provider
      value={{
        companies,
        companyCount: totalCount,
        paginationData,
        selectedAndDefault,
        selectedCompany,
        defaultCompany,
        isSameSelectedAndDefault,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading,
        isFetching,
        isError,
        refetch,
      }}
    >
      {children}
    </WorkspaceContext.Provider>
  );
};

export default WorkspaceContext;
